import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { SideNavBarVisibilityService } from "../../services/side-nav-bar-visibility.service";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { ZpDataService } from "../../services/zp-data.service";
import { Subscription } from "rxjs";
import { UserInfoService } from "../../services/user-info.service";
import { AdminDashboardService } from "../../services/admin-dashboard.service";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
    selector: "app-mail-log-details",
    templateUrl: "./mail-log-details.component.html",
    styleUrls: ["./mail-log-details.component.scss"],
    standalone: false
})
export class MailLogDetailsComponent implements OnInit {
  public routeLinks: any[];
  public chosenTab: string;
  public Id: string;
  public user: {};
  public allUsers: [];
  public showDetailUser: boolean;
  public displayById: boolean = false;
  public dataIsLoading: boolean;
  @Input() public dataUser;
  @Output() public userOutputValue = new EventEmitter();
  @Output() public onClick = new EventEmitter();
  public userById: any;
  public dataIsLoaded;

  constructor(
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private ZpDataService: ZpDataService,
    private admin: AdminDashboardService,
    public themeService: ThemeService
  ) {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.Id = params.get("Id");
    });
  }

  async ngOnInit() {
    let userId = this.Id;
    let data = await this.ZpDataService.findUsers(userId, null);
    this.dataIsLoading = false;
    if (data.success && data.users.length > 0) {
      data.users.forEach((element) => {
        this.userById = element;
        // this.dataUser = element.email_history;
      });
      this.dataIsLoading = true;
      this.displayById = true;
    } else {
      this.displayById = false;
    }
    this.showDetailUser = false;
    // this.user = this.admin.users.find(user => user.Id == this.id)
    this.userOutputValue.emit(this.user);
  }

  goBack(): void {
    this.showDetailUser = false;
    this.onClick.emit();
  }

  goBackUserById() {
    this.location.back();
  }
}
